export default {
  toggle(context) {
    context.commit('TOGGLE_DRAWER');
  }
};
